module.exports = __webpack_public_path__ + "img/BikeParkBox_Radfahrerin_App.1e5e2a16.jpg";